"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClickEventObserver = void 0;
var inversify_1 = require("inversify");
var event_tracking_core_1 = require("@al/event-tracking-core");
var types_1 = require("../types");
var utils_1 = require("../utils");
var processor_1 = require("../utils/processor");
var notifyEvents_1 = require("../constants/notifyEvents");
var ClickEventObserver = /** @class */ (function () {
    function ClickEventObserver() {
        this.prevActiveElement = null;
    }
    ClickEventObserver.prototype.collectData = function (element) {
        return (0, processor_1.processDataset)((0, utils_1.collectDataFromDataset)(element, event_tracking_core_1.CLICK_DATASET_KEY));
    };
    ClickEventObserver.prototype.handleFocus = function () {
        var _a, _b;
        var currentActive = document.activeElement;
        if (this.prevActiveElement === currentActive) {
            return;
        }
        var dataset = currentActive ? currentActive.dataset : {};
        var data = dataset[event_tracking_core_1.INPUT_DATASET_KEY];
        if (currentActive &&
            data &&
            (currentActive.tagName === "INPUT" ||
                currentActive.tagName === "TEXTAREA" ||
                currentActive.isContentEditable)) {
            var inputData = JSON.parse(data);
            var key = inputData.inputKey || ((_b = (_a = inputData === null || inputData === void 0 ? void 0 : inputData.behavior) === null || _a === void 0 ? void 0 : _a.v4) === null || _b === void 0 ? void 0 : _b.inputKey);
            if (key) {
                this.eventOrderBucket.increase(key);
            }
        }
        this.prevActiveElement = document.activeElement;
    };
    ClickEventObserver.prototype.handleExposeClick = function (event) {
        var element = (0, utils_1.findExposeElement)(event.target);
        this.observableService.notify(notifyEvents_1.NOTIFY_EXPOSE_CLICK, {
            element: element,
            event: event,
        });
    };
    ClickEventObserver.prototype.update = function (event) {
        this.handleFocus();
        // 这里依赖了 handleExposeClick 的调用在 notify NOTIFY_CLICK_EVENT 之前，不能变更调用顺序
        // 因为 handleExposeClick 内会触发设置被点击的曝光元素
        this.handleExposeClick(event);
        var data = this.collectData(event.target);
        if (!data) {
            return;
        }
        this.observableService.notify(notifyEvents_1.NOTIFY_CLICK_EVENT, {
            data: data,
            event: event,
        });
    };
    __decorate([
        (0, inversify_1.inject)(event_tracking_core_1.TYPES.IObservableService),
        __metadata("design:type", Object)
    ], ClickEventObserver.prototype, "observableService", void 0);
    __decorate([
        (0, inversify_1.inject)(event_tracking_core_1.TYPES.IEventOrderBucket),
        (0, inversify_1.named)(types_1.TAG.EventOrderBucket),
        __metadata("design:type", Object)
    ], ClickEventObserver.prototype, "eventOrderBucket", void 0);
    ClickEventObserver = __decorate([
        (0, inversify_1.injectable)()
    ], ClickEventObserver);
    return ClickEventObserver;
}());
exports.ClickEventObserver = ClickEventObserver;
